export const NODE_WORKLOADS_TABLE_URL_KEY = 'node-workloads-list';
